import type React from 'react';

import { Link } from '@change/ds-core-ui/Link';
import { TextField } from '@change/ds-forms';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { usePasswordInput } from './hooks/usePasswordInput';

type Props = {
	value: string;
	showHelp?: boolean;
	error?: string | null;
	onChange: (value: string) => void;
};

export const PasswordInput: React.FC<Props> = ({ value: password, showHelp, error, onChange }) => {
	const {
		data: { displayMode },
		actions: { toggleDisplayMode },
	} = usePasswordInput();
	const { translate } = useI18n();

	return (
		<div className="relative">
			{password ? (
				<Link
					className="absolute top-[-2px] right-0 underline"
					as="button"
					variant="secondary"
					type="button"
					aria-label={translate(
						`corgi.login_or_signup.button.a11y.show_password_button.${displayMode === 'password' ? 'show' : 'hide'}`,
					)}
					onClick={toggleDisplayMode}
					aria-pressed={displayMode === 'text'}
					data-testid="password-visibility-toggle"
					data-qa="password-visibility-toggle"
				>
					<Translate
						value={`corgi.login_or_signup.button.show_password_button.${displayMode === 'password' ? 'show' : 'hide'}`}
					/>
				</Link>
			) : null}
			<TextField
				type={displayMode}
				id="loginPassword"
				name="password"
				data-testid="password"
				data-qa="password"
				size="large"
				supportingText={showHelp ? translate('corgi.login_or_signup.common.labels.password_requirement') : undefined}
				label={translate('corgi.login_or_signup.common.labels.password')}
				onChange={onChange}
				value={password}
				isInvalid={!!error}
				errorMessage={error}
			/>
		</div>
	);
};
